import PurchaseOrderChangeRecords from "../PurchaseOrderChangeRecords";

describe("PurchaseOrderChangeRecords model", () => {
  it("should have correct belongsTo relations", () => {
    const relationNames = PurchaseOrderChangeRecords.belongsTo.map(
      relation => relation.name
    );
    expect(relationNames).toMatchSnapshot();
  });
});
